import getMatchedSeoImportantFacet from "./getMatchedSeoImportantFacet";

const isFacetedNavPage = ({ seoImportantFacets, refine }) =>
  Boolean(getMatchedSeoImportantFacet({ seoImportantFacets, refine }));

export default isFacetedNavPage;
